<script setup lang="ts">
// Composant global de confirmation — utilisation via useConfirm()
import { useConfirm } from '@/composables/useConfirm';
const { state, confirm, cancel } = useConfirm();
</script>

<template>
  <Teleport to="body">
    <div v-if="state.isOpen" class="modal-overlay" @click.self="cancel">
      <div class="modal">
        <h2 class="modal-title">{{ state.title }}</h2>
        <p class="modal-message">{{ state.message }}</p>
        <div class="modal-actions">
          <button class="btn btn-ghost btn-sm" @click="cancel">Annuler</button>
          <button class="btn btn-danger btn-sm" @click="confirm">Confirmer</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}

.modal {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 1.5rem;
  max-width: 380px;
  width: 90%;
}

.modal-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.modal-message {
  color: var(--text-muted);
  font-size: 0.875rem;
  margin-bottom: 1.25rem;
}

.modal-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}
</style>
